import { services } from '@/service';
import { lawOptionFilterList } from '@/constant';
import { cloneDeep } from 'lodash';

let mixin = {
  data() {
    return {
      previewListFlag: false,
      searchSelector: '全文',
      searchSelectOption: ['全文', '标题'],
      highSearchFlag: false,
      searchHistoryFlag: false,
      searchHistoryList: [],
      key: [],
      keyWord: ''
    };
  },
  created() {
    // console.log('search-mixin')
  },
  mounted() {
    const lawCaseFilterObj = JSON.parse(sessionStorage.getItem('lawCaseFilterObj')) || {};

    this.searchKey = '';
    // 初始化输入框内容
    // if (lawCaseFilterObj.title && !lawCaseFilterObj.fulltext) {
    //   this.searchSelector = '标题'
    //   this.searchKey = lawCaseFilterObj.title
    // }
    // if (lawCaseFilterObj.fulltext && !lawCaseFilterObj.title) {
    //   this.searchSelector = '全文'
    //   this.searchKey = lawCaseFilterObj.fulltext
    // }
  },
  methods: {
    // 高级检索点击
    highSearchClick(bool, type) {
      this.$emit('highSearchClick', bool);

      if (bool && type && !this.highSearchFlag) {
        bool = false;
      }

      if (!bool && this.highSearchFlag) {
        bool = true;
      }

      if (!bool) {
        this.highSearchFlag = true;
        $('.course-filter').slideDown();
        this.$refs.lawfilter && this.$refs.lawfilter.initSelect();

        if (this.highSearchFlag && this.removeFilter) this.removeFilter();
      } else {
        setTimeout(() => {
          this.highSearchFlag = false;

          if (this.highSearchFlag && this.removeFilter) this.removeFilter();
        }, 500);
        $('.course-filter').slideUp();
      }
    },
    // 搜索内容
    searchBtn(item, btnType) {
      if (item && item.title) {
        this.searchKey = item.title;
      } else {
        if (!this.searchKey) {
          this.$message.warning('请输入搜索内容');
          return;
        }
      }

      const limitNum = 200;

      if (this.searchKey.length >= limitNum) {
        this.$message.warning(`请输入少于${limitNum}个字符的关键词进行检索!`);
        return;
      }

      services.logger.handleLog({ operateName: '法规检索', otherParams: { info: [this.searchKey] } }, '法规');

      this.resultCheckedFlag = btnType == 'result' ? true : false;

      // let chckedboxStyleDisplay = document.querySelector(".pagejump-checkbox") ? window.getComputedStyle(document.querySelector(".pagejump-checkbox"), null).getPropertyValue("display") : '';
      // if (chckedboxStyleDisplay == 'none') {
      //   document.querySelector(".pagejump-checkbox").style.display="flex"
      // }

      if (this.resultCheckedFlag) {
        sessionStorage.setItem('resultChecked', true);
      } else {
        sessionStorage.removeItem('resultChecked');
      }
      window.sessionStorage.setItem('pageJump', false);
      this.saveSearchFilter('normal');
      this.saveMainSearchHistoryList();

      if (!this.resultCheckedFlag) this.$router.push({ query: {} });
      this.goPreview();
    },
    // 储存请求数据
    saveSearchFilter(btnType) {
      if (this.resultCheckedFlag) {
        // 结果中检索
        const lawOptionFilterList = JSON.parse(sessionStorage.getItem('lawOptionFilterList')) || [];
        const item = lawOptionFilterList.find(i => i.name === this.searchSelector);
        let val = item.value.split(' ');
        val.push(this.searchKey);
        item.value = val.join(' ');
        sessionStorage.setItem('lawOptionFilterList', JSON.stringify(lawOptionFilterList));
      } else {
        // 新检索
        const list = cloneDeep(lawOptionFilterList)
        const item = list.find(i => i.name === this.searchSelector);
        item.value = this.searchKey;
        sessionStorage.setItem('lawOptionFilterList', JSON.stringify(list));
      }
      return;
    },
    // 储存历史输入数据
    saveMainSearchHistoryList() {
      let historyList = JSON.parse(localStorage.getItem('mainSearchHistoryList')) || [];
      historyList.forEach((item, key) => {
        if (item == this.searchKey) historyList.splice(key, 1);
      });
      historyList.push(this.searchKey);
      if (historyList.length > 5) historyList.splice(0, 1);
      localStorage.setItem('mainSearchHistoryList', JSON.stringify(historyList));
    },
    // 点击历史内容
    searchHistoryItemClick(index) {
      this.searchKey = this.searchHistoryList[index];

      this.searchBtn();
    },
    // 清除历史搜索
    clearSearchHistory() {
      localStorage.removeItem('mainSearchHistoryList');
      this.searchHistoryList = [];
    },
    // 搜索框获取焦点
    keySearchFocus() {
      this.searchHistoryList = JSON.parse(localStorage.getItem('mainSearchHistoryList')) || [];

      this.searchHistoryList = _.reverse(this.searchHistoryList);
      this.searchHistoryFlag = this.searchHistoryList.length ? true : false;
      this.previewListFlag = true;
    },
    // 搜索框失去焦点
    keySearchBlur() {
      setTimeout(() => {
        this.searchHistoryFlag = false;
        this.previewListFlag = false;
      }, 250);
    }
  }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/views/law/js/search-mixin.js